import Field from "ui/components/Input/Field";
import { Control } from "react-hook-form";
import ModalAddContato from "ui/components/FormContatos/components/ModalAddContato";
import { useState, useRef, useEffect } from "react";
import { Box, Text } from "@chakra-ui/react";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import colors from "core/resources/theme/colors";
import { AiOutlinePlus } from "react-icons/ai";
import TabelaContato from "ui/components/FormContatos/components/TabelaContato";

interface FormContatosProps {
  control: Control<any, object>;
  name?: string;
  hideCobranca?: boolean;
}

export default function FormContatos({
  control,
  hideCobranca,
  name = "contatos",
}: FormContatosProps) {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [indexEdit, setIndexEdit] = useState<number | undefined>();
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (Number.isInteger(indexEdit)) {
      setIsOpenModal(true);
    }
  }, [indexEdit]);

  return (
    <Box ref={containerRef}>
      <Field
        name={name}
        control={control}
        render={({ field }) => (
          <>
            {isOpenModal ? (
              <ModalAddContato
                isOpen={isOpenModal}
                hideCobranca={hideCobranca}
                onClose={() => {
                  setIsOpenModal(false);
                  setIndexEdit(undefined);
                }}
                defaultData={
                  Number.isInteger(indexEdit)
                    ? field.value[indexEdit!]
                    : undefined
                }
                onSaved={(contato) => {
                  if (Number.isInteger(indexEdit)) {
                    const copy = [...field.value];

                    copy.splice(indexEdit!, 1, contato);

                    field.onChange(copy);
                  } else {
                    field.onChange([...field.value, contato]);
                  }
                  setIndexEdit(undefined);
                  setIsOpenModal(false);
                }}
              />
            ) : null}

            <Box display={"flex"} alignItems="center">
              <Text color={"#8291A9"} fontWeight={"500"} fontStyle={"italic"}>
                Contatos
              </Text>

              <PrimaryButton
                style={{
                  minWidth: "21px",
                  height: "21px",
                  padding: 0,
                  background: "transparent",
                  color: `${colors.primary}`,
                  borderRadius: "50%",
                  border: `2px solid ${colors.primary}`,
                  marginLeft: "8px",
                }}
                onClick={() => setIsOpenModal(true)}
              >
                <AiOutlinePlus />
              </PrimaryButton>
            </Box>
            <Box mt="8px">
              <TabelaContato
                data={field.value ?? []}
                isLoading={false}
                containerRef={containerRef}
                onDelete={(index) =>
                  field.onChange(
                    field.value.filter(
                      (_: any, _index: number) => _index !== index
                    )
                  )
                }
                onEdit={setIndexEdit}
              />
            </Box>
          </>
        )}
      />
    </Box>
  );
}
